import React, { useState, useEffect, useRef } from 'react'
import { Form, Row, Col, Container, FloatingLabel, Modal } from 'react-bootstrap';
import { useParams } from "react-router-dom";
import { FaDownload, FaAlignJustify } from 'react-icons/fa';
import ForwardToInboxOutlinedIcon from '@mui/icons-material/ForwardToInboxOutlined';
import ScienceIcon from '@mui/icons-material/Science';
import Spinner from 'react-bootstrap/Spinner';
import Paper from '@mui/material/Paper';
import { Alert, Badge, Snackbar, ToggleButton, ToggleButtonGroup, Tooltip, Typography } from '@mui/material';
import { Accordion, AccordionGroup, Button, Checkbox, Chip, Divider, FormControl, FormLabel, Grid, IconButton, Input, Link, ListItemDecorator, Option, Select, Skeleton, Stack } from '@mui/joy';
import * as apiUtility from '../../config/APIUtils';
import SuccessPopUp from '../Utility/SuccessPopUp';
import ErrorPopUp from '../Utility/ErrorPopUp';
import { PieChart } from '@mui/x-charts/PieChart';
import { Box, Card, CardContent, Sheet } from '@mui/joy';
import VerifiedIcon from '@mui/icons-material/Verified';
import HomeRoleForUser from './HomeRoleForUser';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import Warning from '@mui/icons-material/Warning';
import DocumentScannerOutlinedIcon from '@mui/icons-material/DocumentScannerOutlined';
import NewspaperOutlinedIcon from '@mui/icons-material/NewspaperOutlined';
import Tabs from '@mui/joy/Tabs';
import TabList from '@mui/joy/TabList';
import Tab, { tabClasses } from '@mui/joy/Tab';
import TabPanel from '@mui/joy/TabPanel';
import PolicyDetails from '../Policy_Components/PolicyDetails';
import { useUser } from '../../config/UserContext';
import { PolicyPdfReport } from '../ReportGenerationComponents/PolicyPdfReport';
import { PolicyExcelReport } from '../ReportGenerationComponents/PolicyExcelReport';
import { useUserCourse } from '../../config/UserCourseContext';
import CourseVersionDetails from './CourseVersionDetails';
import { CourseExcelReport } from '../ReportGenerationComponents/CourseExcelReport';
import { CoursePdfReport } from '../ReportGenerationComponents/CoursePdfReport';
import RoleConfirmationPopup from './RoleConfirmationPopup';
import { DataGrid } from '@mui/x-data-grid';
import MoreHorizRoundedIcon from '@mui/icons-material/MoreHorizRounded';
import SystemUpdateAltOutlinedIcon from '@mui/icons-material/SystemUpdateAltOutlined';
import CloseIcon from '@mui/icons-material/Close';
import CheckRoundedIcon from '@mui/icons-material/CheckRounded';
import TimerOutlinedIcon from '@mui/icons-material/TimerOutlined';
import AddTaskIcon from '@mui/icons-material/AddTask';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import ParentCoursePopup from './ParentCoursePopup';
import CourseRegistrationHistory from './CourseRegistrationHistory';
import AccordionDetails, { accordionDetailsClasses, } from '@mui/joy/AccordionDetails';
import AccordionSummary, { accordionSummaryClasses, } from '@mui/joy/AccordionSummary';
import HelpIconInfo from '../Utility/HelpIconBox';
import { useNavigate } from 'react-router-dom';
import LaunchIcon from '@mui/icons-material/Launch';


function ManageMyTrainings(props) {
    var paramId = useParams().id;
    var propsId = props.userId;
    var params = propsId;
    if (!propsId) {
        params = paramId;
    }

    var homeTypes = JSON.parse(sessionStorage.getItem("home_types"));

    const [tabIndex, setTabIndex] = React.useState(0);
    const [reportType, setReportType] = React.useState(0);
    const colors = ['primary', 'danger', 'success', 'warning'];
    const [mappingData, setMappingData] = useState([{ '': '' }]);
    const [homeId, sethomeId] = useState(0);
    const [roleId, setroleId] = useState(0);
    const [userId, setuserId] = useState(0);
    const [homeList, sethomelist] = useState([{ '': '' }]);
    const [roleList, setroleList] = useState([{ '': '' }]);
    const [completeCourses, setCompleteCourses] = useState([]);
    const [waitMsg, setWaitMsg] = useState('Loading..');

    const [alertshow, setalertShow] = useState(false);
    const [successAlertshow, setsuccessAlertshow] = useState(false);

    const [format, setformat] = useState(0);
    const [empEmailId, setempEmailId] = useState('');
    //const [userList, setUserList] = useState([]);
    const [mapHomeList, setmapHomeList] = useState([]);
    const [mapRoleList, setmapRoleList] = useState([]);

    const [auditCheck, setAuditCheck] = useState(true);
    const [showSpinner, setShowSpinner] = useState(false);
    const [pendingRole, setPendingRole] = useState(false);
    const [roleLabel, setRoleLabel] = useState("Role Assignment Filter");

    const [showSuccess, setShowSuccess] = useState(false);
    const [successMsg, setsuccessMsg] = useState(false);
    const [showErrorMsg, setShowErrorMsg] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [allHomesBox, setAllHomeBox] = useState(false);

    const [externalSearch, setExternalSearch] = useState(false);
    const [extHomeName, setExtHomeName] = useState('');
    const [extRoleName, setExtRoleName] = useState('');

    const [filterSearch, setFilterSearch] = useState(false);

    const [homeDropdownValue, sethomeDropdownValue] = useState(0);
    const [roleDropdownValue, setroleDropdownValue] = useState(0);

    const [courseVersionModal, setCourseVersionModal] = useState(false);
    const [parentCoursePopupFlag, setParentCoursePopupFlag] = useState(null);
    const [courseHistoryPopupFlag, setCourseHistoryPopupFlag] = useState(null);
    const [courseBadgeTableData, setCourseBadgeTableData] = useState({});


    const [pieData, setPieData] = useState([
        { id: 0, value: 0, label: 'Outstanding' },
        { id: 1, value: 0, label: 'Validated' },
        { id: 2, value: 0, label: 'Expired' },
    ]);

    //const BASE_URL_EMAIL_TO_EMPLOYER = "user/sendEmailEmp";
    const GET_HOME_ROLE_BASED_POLICIES = "policy/processUserRegistry";
    const BASE_URL_GET_All_HOMELIST = "orgnization/getAllHomes";
    //const BASE_URL_GET_COURSELIST = "course/fetchCourseDetails";
    const BASE_URL_GET_USER_HOME_ROLE = "user/fetchUHRdetails/";
    const BASE_URL_GET_HOME_ROLE_CRS_LIST = "orgnization/getHomeInfo/";
    const BASE_URL_USER = "user/getUser/";
    const BASE_URL_GET_COURSELIST = "course/fetchCourseGrid";
    const BASE_COURSE_LOGIN_URL = "user/fetch-course-login-url";
    
    //const BASE_URL_GET_ALLCOURSE_VERSIONS_USER_BASED = "course/getAllCourseVersion_forUser";
    const BASE_GET_USER_BADGE_URL_DATA = "course/fetchUserCourseRegistrations/";

    const { updateUserDetails, updateGlobalRoleDetails, updateGlobalHomeDetails, policyDataList, userData, homeDetail, trainingProviders,
        roleDetail, pendingPolicyCount, updateCurrentPolicyDataList, updatePendingPolicyCount, updateTrainingProviders } = useUser();

    const { screenDetails: { fieldSize, stackOrientation } } = useUser();

    const { pendingCourseCount, cartCourseList = {}, enrolledCourses = [], updatePendingCourseCount, resetEnrolledCourses } = useUserCourse();


    var mapOfHomeType = {};

    homeTypes.forEach(element => {
        mapOfHomeType[element.id] = element.value;
    });

    const navigate = useNavigate();
    const { home } = useParams() || {};
    const currentHome = home || '';

    //const tableRef = useRef();

    // useEffect(() => {
    //     const handleResize = () => setIsMobile(window.innerWidth < 768);
    //     window.addEventListener('resize', handleResize);
    //     return () => window.removeEventListener('resize', handleResize);
    // }, []);

    // eslint-disable-next-line
    useEffect(() => {
        if (sessionStorage.getItem("userType") !== 'admin' && sessionStorage.getItem("userId") !== paramId) {
            console.log("Unauthorized access attempt to ManageMyTrainings. Redirecting to home.");
            return (currentHome ? navigate(`/${currentHome}/login`) : navigate(`/login`));
        }

        setShowSpinner(true);
        updateTrainingProviders();
        fetchUserData();
        setuserId(params);
        fetchHomeRoleMappingData();
        setShowSpinner(false);
    }, [params]);

    useEffect(() => {
        try {
            // If there are no enrolled courses to merge, don't touch the grid.
            // This prevents the effect from clobbering freshly-loaded API data
            // (e.g. after resetEnrolledCourses() clears the context on a refresh).
            if (!enrolledCourses || enrolledCourses.length === 0) {
                return;
            }

            let updated = completeCourses?.map(c => {
                const enrolled = enrolledCourses?.some(e => e.courseId === c.crsId);
                let statusV = enrolled ? 'Enrolled' : c.status;

                if (enrolled) return { ...c, status: statusV };

                return c;
            });

            //order updated course by enrolled courses at top and regular courses at bottom
            updated = updated?.sort((a, b) => {
                if (a.status === 'Enrolled' && b.status !== 'Enrolled') return -1;
                if (b.status === 'Enrolled' && a.status !== 'Enrolled') return 1;
                return 0;
            });

            //console.log("Updated complete courses list based on enrolled courses: ", updated);
            //updatePendingCourseCount(fetchPendingCourseCount(updated));
            setCompleteCourses(updated);

        } catch (err) {
            console.error("Error updating completeCourses from cartCourseList:", err);
        }
    }, [enrolledCourses]);


    async function fetchUserData() {
        const getUserData = BASE_URL_USER + params
        let apiRequest = apiUtility.apiInputRequest;
        apiRequest.endPoint = getUserData;
        await apiUtility.fetchAsyncAPIDataGET(apiRequest).then(response => {
            //setUserList(response.data.data);
            updateUserDetails(response.data.data)
        }).catch((err) => {
            setShowSpinner(false);
            console.log("Error while fetching User Details: ", err);
        });
    }

    const fetchHomeRoleMappingData = async () => {
        let apiRequest = apiUtility.apiInputRequest;
        const getUserHomeRoleData = BASE_URL_GET_USER_HOME_ROLE + params;
        apiRequest = apiUtility.apiInputRequest;
        apiRequest.endPoint = getUserHomeRoleData;
        apiUtility.fetchAPIDataGET(apiRequest).then(response => {
            if (response.data !== "No User-Role-Home Mapping Found!") {
                setMappingData(response.data);
                getHomeList(response.data);
            } else {
                getHomeList("");
            }
        }).catch((err) => {
            setShowSpinner(false);
            console.log("Error while fetching Home Role Mapping for user: ", err);
        });
    }

    const fetchPoliciesData = async (selectedHomeId, selectedRoleId) => {

        let apiRequest = apiUtility.apiInputRequest;
        apiRequest.endPoint = GET_HOME_ROLE_BASED_POLICIES;
        apiRequest.data = { roleId: selectedRoleId, homeId: selectedHomeId, userId: userData.user_id };
        apiUtility.sendAPIDataPOST(apiRequest).then(resp => {
            let res = resp.data;
            if (res.message !== undefined && res.message === "Success") {
                updateCurrentPolicyDataList(res.data);
                updatePendingPolicyCount(fetchPendingPolicyCount(res.data));
            } else {
                updateCurrentPolicyDataList([]);
                updatePendingPolicyCount(0);
            }

        }).catch(err => {
            setShowSpinner(false);
            console.log("Policy Data not fetched due to error: ", err);
        });
    }

    const fetchPendingPolicyCount = (policyList) => {
        let pendindPolicies = policyList?.filter(rowData => rowData.status === undefined || rowData.status === 'Pending' || rowData.status === 'Expired');
        return pendindPolicies === undefined ? 0 : pendindPolicies.length;
    }

    async function calculatePieData(dataArr, newTabValue) {
        if (newTabValue !== undefined && newTabValue === 1)
            dataArr = policyDataList;
        else if (newTabValue !== undefined && newTabValue === 2)
            dataArr = [...policyDataList, ...completeCourses]
        else
            dataArr = (dataArr !== undefined && dataArr.length > 0) ? dataArr : completeCourses

        let expired = 0;
        let validated = 0;
        let total = 0;

        dataArr = (dataArr === undefined) ? [] : dataArr
        for (const data of dataArr) {
            total++;
            if (data.status === "Expired")
                expired++;
            else if (data.status === "Validated")
                validated++;
        }
        total = total - (expired + validated);
        const tempData = [
            { id: 0, value: total, label: 'Outstanding', color: '#0c6ccc' },
            { id: 1, value: validated, label: 'Validated', color: '#1a8754' },
            { id: 2, value: expired, label: 'Expired', color: '#cf1f1f' },
        ]
        setPieData(tempData);
    }


    const getHomeList = (resp) => {
        try {
            let apiRequest = apiUtility.apiInputRequest;
            apiRequest.endPoint = BASE_URL_GET_All_HOMELIST;
            apiUtility.fetchAPIDataGET(apiRequest).then(response => {
                let allHomesList = response.data;
                let list = [];
                if (resp !== "") {
                    for (const c of allHomesList) {
                        const matched = resp.some((s) => c.home_id === s.home_id);
                        if (matched)
                            list.push(c)
                    }
                }
                setmapHomeList(list);
                sethomelist(response.data);

            });
        } catch (error) {
            setShowSpinner(false);
            console.log("Error while fetching Home List: ", error);
        }
    };

    const filterRoleDropdown = e => {
        setShowSpinner(true);
        setCompleteCourses([]);
        const { value } = e.target
        sethomeId(value);
        sethomeDropdownValue(value);
        setroleDropdownValue(0);
        setExternalSearch(false);
        setFilterSearch(true);
        setRoleLabel("Role Assignment Filter");
        if (value !== 0) {
            setroleList([{ '': '' }]);
            const getUserData = BASE_URL_GET_HOME_ROLE_CRS_LIST + value
            let apiRequest = apiUtility.apiInputRequest;
            apiRequest.endPoint = getUserData;
            apiUtility.fetchAPIDataGET(apiRequest).then(function (response) {
                setroleList(response.data.result);
                let list = [];
                response.data.result.forEach((course) => {
                    mappingData.forEach((mapping) => {
                        if (course.home_id === mapping.home_id) {
                            const matchedRole = mapping.role_arr.find(
                                (role) =>
                                    role.role_id === course.role_id &&
                                    (role.emp_status === "Active" || role.emp_status === "Hold")
                            );
                            if (matchedRole) {
                                course["status"] = matchedRole.emp_status;
                                list.push(course);
                            }
                        }
                    });
                });

                setmapRoleList(list);


                let homeName = mapHomeList.filter((d) => value === d.home_id).map((e) => e.name)
                updateGlobalHomeDetails({ "homeId": value, "homeName": homeName[0] });

                setShowSpinner(false);
                if (response.data.result.length === 0) {
                    setWaitMsg("There is no role mapped with selected Home.")
                    setalertShow(true);
                    setShowSpinner(false);
                }
            })
                .catch(function (error) {
                    setShowSpinner(false);
                });;
        }

    }

    // const fetchRoleList = (homeId) => {
    //     setShowSpinner(true);
    //     if (homeId !== 0) {
    //         setroleList([{ '': '' }]);
    //         const getUserData = BASE_URL_GET_HOME_ROLE_CRS_LIST + homeId
    //         let apiRequest = apiUtility.apiInputRequest;
    //         apiRequest.endPoint = getUserData;
    //         apiUtility.fetchAPIDataGET(apiRequest).then(function (response) {
    //             setroleList(response.data.result);
    //             var list = [];
    //             response.data.result.map((c) => {
    //                 const inner = mappingData.find(
    //                     (s) => {
    //                         // //console.log("Check roles Home => ",c.home_id, "   ", s.home_id);
    //                         if (c.home_id === s.home_id) {
    //                             ////console.log("Check roles Role => ",c.role_id);
    //                             s.role_arr.find(
    //                                 (v) => {
    //                                     ////console.log("Role inner loop => ",v ," ", v.role_id == c.role_id, " ", v.emp_status == "Active")
    //                                     if (v.role_id == c.role_id && (v.emp_status == "Active" || v.emp_status == "Hold")) {
    //                                         c["status"] = v.emp_status;
    //                                         list.push(c)
    //                                     }
    //                                 })
    //                         }
    //                     });
    //                 return (inner);
    //             });
    //             //console.log("Home Id : ",value," Role list: ", roleList);
    //             setmapRoleList(list);
    //             setShowSpinner(false);
    //             if (response.data.result.length === 0) {
    //                 setWaitMsg("There is no role mapped with selected Home.")
    //                 setalertShow(true);
    //                 setShowSpinner(false);
    //             }
    //         })
    //             .catch(function (error) {
    //                 setShowSpinner(false);
    //                 //console.log(error);
    //             });;
    //     }
    // }

    const setRoleValue = e => {
        const { value } = e.target
        setroleId(value);
        setroleDropdownValue(value);
        setExternalSearch(false);
        setFilterSearch(true);
        updateCurrentPolicyDataList([]);
        updatePendingPolicyCount(0);
        if (value === "0" || value === 0) {
            setRoleLabel("Role Assignment Filter");
        } else {
            let pendingSelected = false;
            (mapRoleList.some(data => data.role_id === value && data.status !== "Active")) ? pendingSelected = true : pendingSelected = false;

            if (pendingSelected) {
                setPendingRole(true);
                setRoleLabel("Role - Pending");
            } else {
                //console.log("Confirmed :  ", value);
                setRoleLabel("Role - Confirmed");
                fetchCourseDetails(homeDropdownValue, value);
                fetchPoliciesData(homeDropdownValue, value);
            }


            let roleName = mapRoleList.filter((data) => data.role_id === value).map((d) => d.role_name);
            updateGlobalRoleDetails({ "roleId": value, "roleName": roleName[0] })

        }


    }

    const confirmRole = () => {
        setPendingRole(false);
        if (roleDropdownValue !== undefined && roleDropdownValue !== "") {
            let apiRequest = apiUtility.apiInputRequest;
            apiRequest.endPoint = "orgnization/manualStaffVerification/" + userId + "/" + homeId + "/" + roleDropdownValue;
            apiUtility.fetchAPIDataGET(apiRequest).then(res => {
                if (res.data === "Successfully Confirmed!") {
                    setRoleLabel("Role - Confirmed");
                    fetchPoliciesData(homeId, roleDropdownValue);
                    setsuccessMsg("Successfully Confirmed!");
                    setShowSuccess(true);
                } else {
                    setErrorMsg("Error while confirming!");
                    setShowErrorMsg(true);
                }
                fetchCourseDetails();
            }).catch(e => {
                setErrorMsg("Error while confirming!");
                setShowErrorMsg(true);
            });
        }
    }

    const resetDetails = (crsId) => {
        setShowSpinner(true);
        sethomeDropdownValue(0);
        setroleDropdownValue(0);
        sethomeId(0);
        setroleId(0);
        setRoleLabel("Role Assignment Filter");
        setPendingRole(false);
        setFilterSearch(false);
        let apiRequest = apiUtility.apiInputRequest;

        apiRequest.endPoint = BASE_URL_GET_COURSELIST;
        apiRequest.data = { userId: params  };
        apiUtility.sendAPIDataPOST(apiRequest).then(response => {
            let responseData = (response.data.userCourses !== undefined) ? response.data.userCourses : [];
            let newProducts = [...responseData];
            resetEnrolledCourses();

            //let pendingList = (cartCourseList["pending"]?.length > 0) ? cartCourseList["pending"] : []
            // newProducts = newProducts?.userCourses.map((d) => {
            //     let courseVersionsAdded = false;
            //     // pendingList.forEach(element => {
            //     //     if (element.courseId === d.crsId) {
            //     //         courseVersionsAdded = true;
            //     //     }
            //     // });
            //     if (courseVersionsAdded || (crsId !== undefined && d.crsId === crsId)) {
            //         return {
            //             ...d,
            //             sessionApproved: true
            //         };
            //     }
            //     return d;
            // });
            setCompleteCourses([...newProducts]);
            calculatePieData(responseData, 0);
            updateCurrentPolicyDataList([]);
            updatePendingPolicyCount(0);
            updatePendingCourseCount(0);
        });
        setShowSpinner(false);
    }

    const fetchCourseDetails = (tempHomeId, tempRoleId) => {
        try {
            setShowSpinner(true);
            let resJson = [];
            setCompleteCourses([]);
            setWaitMsg('');

            let roleIdToProceed = 0;
            let homeIdToProceed = homeId;

            if (roleId !== 0 && roleId !== "0") {
                roleIdToProceed = roleId;
            } else if (roleDropdownValue !== 0 && roleDropdownValue !== "0") {
                roleIdToProceed = roleDropdownValue;
            }

            if (tempRoleId !== undefined && tempRoleId !== 0 && tempRoleId !== "0") {
                roleIdToProceed = tempRoleId;
            }

            if (tempHomeId !== undefined && tempHomeId !== 0 && tempHomeId !== "0") {
                homeIdToProceed = tempHomeId;
            }

            (mapRoleList.some(item => item.role_id === roleIdToProceed)) ? setsuccessAlertshow(true) : setsuccessAlertshow(false);
            let apiRequest = apiUtility.apiInputRequest;
            apiRequest.endPoint = BASE_URL_GET_COURSELIST;
            apiRequest.data = { userId: userId, orgId: "", roleId: roleIdToProceed, homeId: homeIdToProceed, courseType: 0, category: "Filter" };
            apiUtility.sendAPIDataPOST(apiRequest).then(res => {
                resJson = res.data;
                resetEnrolledCourses();
                
                if (resJson !== undefined) {
                    if (resJson.courseError) {
                        setWaitMsg("Cannot fetch courses. Try searching with different search criteria.")
                        setalertShow(true);
                        setShowSpinner(false);
                        setsuccessAlertshow(false);
                    } else {
                        const list = resJson.userCourses;

                        setCompleteCourses(list);
                        calculatePieData(list, 0)

                        if (filterSearch === true)
                            updatePendingCourseCount(fetchPendingCourseCount(list));
                        else
                            updatePendingCourseCount(0);

                        setShowSpinner(false);
                        if (list.length === 0) {
                            setWaitMsg("No courses are assigned to this Home and Role.  If you feel that this is incorrect, please contact the Care Passport portal admin at your Home.")
                            setalertShow(true);
                        }
                    }
                } else {
                    setShowSpinner(false);
                    return alert("Selected role don't have courses specified yet. Please contact admin and try again");
                }
            })
                .catch(err => {
                    console.log(err);
                    setShowSpinner(false);
                })
        } catch (error) {
            console.log(error);
            setShowSpinner(false);
        }
    }

    const fetchPendingCourseCount = (courseList) => {
        let pendingCourses = courseList?.filter(rowData => rowData.status === undefined || rowData.status === 'Pending' || rowData.status === '--' || rowData.status === 'Expired');
        return pendingCourses === undefined ? 0 : pendingCourses.length;
    }

    const fetchUsrCourseHistory = (row) => {
        if (row.crsId === undefined || row.crsId === "") {
            setCourseBadgeTableData([]);
            return;
        }
        let apiRequest = apiUtility.apiInputRequest;
        apiRequest.endPoint = BASE_GET_USER_BADGE_URL_DATA
        apiRequest.data = { userId: userData.user_id, crsId: row.crsId };
        apiUtility.sendAPIDataPOST(apiRequest).then(resp => {
            let data = {
                parent: row,
                history: resp.data
            }
            setCourseBadgeTableData(data);
            setCourseHistoryPopupFlag(true);
        }).catch(err => {
            console.log("Course History Data not fetched due to error: ", err);
        });
    }


    const handleUpdateCallback = (courseObj) => {
        if (homeDropdownValue !== 0 || roleDropdownValue !== 0) {
            setExternalSearch(false);
            setFilterSearch(false);
            fetchCourseDetails();
            //TO-DO: Need to optimize this part
            //Update only that Policy instead of fetching all policies again
            fetchPoliciesData(homeDropdownValue, roleDropdownValue);
        } else {
            resetDetails(courseObj);
        }
    }

    async function fetchCourseLoginUrl(crs_code){
        let apiRequest = apiUtility.apiInputRequest;
        apiRequest.endPoint = BASE_COURSE_LOGIN_URL;
        apiRequest.data = { userId: userData.user_id, crs_code: crs_code };
        apiUtility.sendAPIDataPOST(apiRequest).then(res => {
            if (res.data.success === true && res.data?.loginUrl !== "") {
                window.open(res.data.loginUrl, '_blank', 'noopener,noreferrer');
            } else {
                setErrorMsg('Failed to retrieve redirect URL.')
                setShowErrorMsg(true);
            } 
        }).catch((error) => {
            setErrorMsg("Error while fetching course login URL. Please try again later.");
            setShowErrorMsg(true);
        });
    }



    const selectedRowRef = useRef(null);
    const openCourseVersionModal = (row) => {
        selectedRowRef.current = row;
        setCourseVersionModal(true);
    };

    const selectedRowParentCourseRef = useRef(null);
    const openParentCoursePopup = (row) => {
        selectedRowParentCourseRef.current = row;
        setParentCoursePopupFlag(true);
    };

    const data_tables_columns = [
        {
            field: 'crsId',
            headerName: 'Course Code',
            width: 200,
            maxWidth: 300,
            marginLeft: 5,
            align: 'center',
            headerAlign: 'center',
            hideable: false,
            renderCell: (params) => {
                let isEnrolled = enrolledCourses?.find(course => course.courseId === params.row.crsId);
                
                let db_course_enrl_status = (params.row.enrolledCrsVersion === '' || params.row.enrolledCrsVersion === "--") ? false : true;
                
                let enrolled_course_version_code = (isEnrolled !== undefined && isEnrolled?.tp_course_code) ? isEnrolled.tp_course_code : params.row.enrolledCrsVersion;
                
                if (db_course_enrl_status || (isEnrolled !== undefined && isEnrolled?.course_url)) {
                   return (
                        <Tooltip Tooltip title="Launch Course" variant="outlined" color="warning" arrow placement="bottom">
                            <IconButton size="sm" 
                                sx={{ 
                                        position: 'relative', 
                                        overflow: 'hidden',
                                         borderRadius: "30px",
                                         height: "0.6em",
                                         maxHeight: "1.2em",
                                         padding: "1px 10px",
                                         "fontSize": 'var(--joy-fontSize-sm, 0.9em)',
                                         
                                        '&::after': {
                                            content: '""',
                                            position: 'absolute',
                                            inset: 0,
                                            background: 'linear-gradient(90deg, transparent, rgb(253, 241, 255, 1), transparent)',
                                            animation: 'shimmer 1.8s infinite',
                                            pointerEvents: 'none',
                                        },
                                       
                                        '@keyframes shimmer': {
                                            '0%': { transform: 'translateX(-100%)' },
                                            '100%': { transform: 'translateX(100%)' },
                                        },
                                    }} 
                                onClick={() => fetchCourseLoginUrl(enrolled_course_version_code)} >
                                <LaunchIcon sx={{ height: "0.7em" }}/>
                                {params.row.crsId}
                            </IconButton>
                        </Tooltip>
                        
                    )
                } else {
                    return (
                        <IconButton color="primary" sx={{
                            borderRadius: "30px",
                            height: "0.6em",
                            maxHeight: "1.2em",
                            padding: "1px 10px",
                            "fontSize": 'var(--joy-fontSize-sm, 0.9em)'
                        }} size="sm" variant="outlined" onClick={() => {
                            let rowData = params.row;
                            openCourseVersionModal(rowData);
                        }} >
                            <Typography variant="body-md" sx={{ color: "#016799" }}>
                                <StorefrontOutlinedIcon sx={{ height: "0.7em" }} />
                                {params.row.crsId}
                            </Typography>
                        </IconButton>
                    )
                }
            
                
            }

        },
        {
            field: 'direct_registration',
            headerName: '',
            maxWidth: 10,
            width: 10,
            headerAlign: 'center',
            hideable: false,
            sortable: false,
            center: true,
            renderCell: (params) => {
                if (params.row.directRegistration !== undefined && params.row.directRegistration && params.row.status === 'Enrolled') {
                    return (
                        <Tooltip title="Enrolled with Direct Registration" arrow>
                            <VerifiedIcon style={{ fontSize: '1.4pc', marginTop: '2px' }} color='success' />
                        </Tooltip>
                    )
                } else if (params.row.directRegistration !== undefined && params.row.directRegistration) {
                    return (
                        <Tooltip title="Available for Direct Registration" arrow>
                            <VerifiedIcon style={{ fontSize: '1.4pc', marginTop: '2px' }} color='primary' />
                        </Tooltip>
                    )
                } else {
                    return (<></>)
                }

            }
        },
        {
            field: 'title',
            headerName: 'Title',
            headerAlign: 'center',
            width: 400,
            maxWidth: 600,
            hideable: false,
            renderCell: (params) => (
                <Link component="button" onClick={() => openParentCoursePopup(params.row)} sx={{ cursor: 'pointer', color: "black" }}>
                    <Typography variant="body2" title={params.row.title} sx={{
                        whiteSpace: 'normal',
                        wordBreak: 'break-word',
                        overflowWrap: 'break-word',
                        lineHeight: 1.2,
                        textAlign: 'left',
                    }}>
                        {params.row.title}
                    </Typography>
                </Link>
            )
        },
        // ...(!isMobile ? [
        //     {
        //         field: "description",
        //         headerName: "Description",
        //         width: 300,
        //         headerAlign: 'center',
        //     },
        // {
        //     field: "courseType",
        //     headerName: "Applicable Industry",
        //     sort: true,
        //     width: 150,
        //     //formatter: industryFormatter
        // }
        // ] : []),
        {
            headerName: 'Valid For',
            description: 'This column has a value getter and is not sortable.',
            sortable: false,
            width: 180,
            maxWidth: 200,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => {
                const rowData = params.row;
                return (

                    rowData.validity_string === '' ? (
                        <Chip color="success" size="sm" variant="soft">
                            <MoreHorizRoundedIcon sx={{ height: "0.6em" }} />No expiry&nbsp;
                        </Chip>
                    ) : rowData.validity?.years > 0 ? (

                        rowData.validity?.months > 0 ?
                            <Chip color="primary" size='sm' variant="soft" >
                                <TimerOutlinedIcon sx={{ height: "0.6em" }} />{rowData.validity?.years + " yr " + rowData.validity?.months + " months"}
                            </Chip>
                            :
                            <Chip color="primary" size='sm' variant="soft" >
                                <TimerOutlinedIcon sx={{ height: "0.6em" }} />{rowData.validity?.years + " years"}&nbsp;
                            </Chip>
                    ) : (
                        <Chip color="primary" size="sm" variant="soft">
                            <TimerOutlinedIcon sx={{ height: "0.6em" }} />{rowData.validity?.months + " months"}&nbsp;
                        </Chip>
                    )

                );
            }
        },
        {
            field: 'status',
            headerName: 'Status',
            description: 'This column has a value getter and is not sortable.',
            sortable: true,
            width: 160,
            maxWidth: 180,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => {
                const rowData = params.row;
                return (
                    (!filterSearch && (rowData.status === undefined || rowData.status === 'Pending' || rowData.status === '--')) ? (
                        <></>
                    ) :
                        rowData.status === undefined || rowData.status === 'Pending' || rowData.status === '--' || rowData.status === 'Enrolled' ? (
                            <Chip color="warning" size="sm" variant="soft">
                                <MoreHorizRoundedIcon sx={{ height: "0.6em" }} />{(rowData.status === 'Enrolled') ? "Enrolled" : "Due"}&nbsp;&nbsp;&nbsp;&nbsp;
                            </Chip>

                        ) : rowData.status === 'Validated' ? (

                            <Chip color="success" size='sm' variant="soft"><CheckRoundedIcon sx={{ height: "0.6em" }} />Validated</Chip>
                        ) : (
                            <Chip color="danger" size="sm" variant="soft"><CloseIcon sx={{ height: "0.6em" }} />Expired&nbsp;&nbsp;</Chip>
                        )
                );
            }
        },
        {
            field: 'expiry_date',
            headerName: 'Expiry Date',
            description: 'This column has a value getter and is not sortable.',
            sortable: true,
            width: 160,
            maxWidth: 180,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => {
                const rowData = params.row;
                return (
                    (rowData.status !== "Enrolled" && rowData?.valid !== '') ? <Typography variant="overline"> {rowData.valid}</Typography> : ""
                );
            }
        },
        {
            field: 'history',
            headerName: 'View',
            description: 'Depicts user course registration hisotry',
            sortable: false,
            width: 160,
            maxWidth: 180,
            align: 'center',
            headerAlign: 'center',
            renderCell: (params) => {
                const rowData = params.row;

                return (

                    <IconButton color="primary" sx={{
                        borderRadius: "30px",
                        height: "0.6em",
                        maxHeight: "1.2em",
                        padding: "1px 10px",
                        "fontSize": 'var(--joy-fontSize-sm, 0.9em)'
                    }} size="sm" variant="outlined" onClick={() => fetchUsrCourseHistory(params.row)} >
                        <Typography variant="caption" sx={{ color: "#016799" }}> <SystemUpdateAltOutlinedIcon sx={{ height: "0.7em" }} />History&nbsp;</Typography></IconButton>


                );
            }
        },
    ];

    // const columns = [
    //     {
    //         dataField: "crsId",
    //         text: "",
    //         headerFormatter: () => <span>Course Code</span>,
    //         sort: true,
    //         filter: textFilter({ placeholder: 'Course Code ...' }),
    //         formatter: courseCodeFormatter,
    //         style: {
    //             fontWeight: 'bold',
    //             height: '5%'
    //         }

    //     },
    //     {
    //         dataField: "title",
    //         text: "",
    //         headerFormatter: () => <span>Title</span>,
    //         sort: true,
    //         filter: textFilter({ placeholder: 'Title ...' }),
    //         title: (cell, row, rowIndex, colIndex) => `${cell}`
    //     },
    //     ...(!isMobile ? [
    //         {
    //             dataField: "description",
    //             text: "Description",
    //         },
    //         {
    //             dataField: "courseType",
    //             text: "Applicable Industry",
    //             sort: true,
    //             formatter: industryFormatter
    //         }
    //     ] : []),
    //     {
    //         dataField: "validity_string",
    //         text: "Valid For ",
    //     },
    //     {
    //         dataField: "status",
    //         text: "Status",
    //         formatter: crsStatusFormatter
    //     },
    //     {
    //         dataField: "valid",
    //         text: "Expiry Date",
    //         formatter: expiryDateFormatter
    //         //formatter: expiryFormatter
    //     }
    //     // {
    //     //     dataField: "",
    //     //     text: "View",
    //     //     formatter: buttonFormatter
    //     // }
    // ];

    const updateEmpEmailId = e => {
        const { value } = e.target;
        setempEmailId(value);
        setShowSuccess(false);
    }

    const sendDataThroughEmail = () => {
        let response = {};
        if (!auditCheck || empEmailId === undefined || empEmailId === "") {
            setErrorMsg("Please verify and enter valid email id");
            setShowErrorMsg(true);
            return;
        }
        setShowSpinner(true);
        userData["homeName"] = homeDetail.homeName;
        userData["roleName"] = roleDetail.roleName;
        userData["empEmailId"] = empEmailId;
        let reportName = 'Course Completion Report';
        let fileName = 'Carepassport_eCompletionReport_' + userData?.user_id;

        if (reportType === 0) {
            // if (format == 0)
            //     exportAuditExcel(true);
            // else
            //     exportAuditPDF(true);

            reportName = 'Course Completion Report';
            fileName = 'Carepassport_eCompletionReport_' + userData?.user_id;
            if (format === 0)
                response = CourseExcelReport(userData, completeCourses, trainingProviders, reportName, fileName, true)
            else
                response = CoursePdfReport(userData, completeCourses, trainingProviders, reportName, fileName, true);
        } else {

            reportName = (reportType === 1) ? 'Home Docs Completion Report' : 'Course & Home Docs Completion Report';
            fileName = (reportType === 1) ? 'Carepassport_eHomeDocsCompletionReport_' + userData?.user_id : 'Carepassport_eCompletionReport_' + userData?.user_id;
            if (format === 0)
                response = PolicyExcelReport(userData, policyDataList, completeCourses, trainingProviders, reportName, fileName, true, reportType)
            else
                response = PolicyPdfReport(userData, policyDataList, completeCourses, trainingProviders, reportName, fileName, true, reportType);
        }
        if (response?.code === 200) {
            setsuccessMsg(response.data);
            setShowSuccess(true);
        }
        setShowSpinner(false);
    }

    const downloadData = async e => {
        let response = {};
        userData["homeName"] = homeDetail.homeName;
        userData["roleName"] = roleDetail.roleName;
        let reportName = "";
        let fileName = "";
        setShowSpinner(true);
        if (reportType === 0) {
            reportName = 'Course Completion Report';
            fileName = 'Carepassport_CompletionReport_' + userData?.user_id;
            if (format === 0)
                response = CourseExcelReport(userData, completeCourses, trainingProviders, reportName, fileName, false)
            else
                response = CoursePdfReport(userData, completeCourses, trainingProviders, reportName, fileName, false);
        } else {

            reportName = (reportType === 1) ? 'Home Docs Completion Report' : 'Course & Home Docs Completion Report';
            fileName = (reportType === 1) ? 'Carepassport_HomeDocsCompletionReport_' + userData?.user_id : 'Carepassport_CompletionReport_' + userData?.user_id;
            if (format === 0)
                response = await PolicyExcelReport(userData, policyDataList, completeCourses, trainingProviders, reportName, fileName, false, reportType)
            else
                response = await PolicyPdfReport(userData, policyDataList, completeCourses, trainingProviders, reportName, fileName, false, reportType);
        }
        if (response?.code === 200) {
            setsuccessMsg('File downloaded successfully.');
            setShowSuccess(true);
        }
        setShowSpinner(false);
        setTimeout(() => closeAlert, 6000);
    }
    const closeAlert = () => {
        setalertShow(false);
        setsuccessAlertshow(false);
    }


    const formatChange = value => {
        (value === "pdf") ? setformat(1) : setformat(0);
        setShowSuccess(false);

    }


    function handleModalData(homeRoleMap) {
        const newHomeId = homeRoleMap["homeId"] || 0;
        const newRoleId = homeRoleMap["roleId"] || 0;

        setAllHomeBox(false);
        sethomeId(newHomeId);
        setroleId(newRoleId);

        setRoleLabel("Role Assignment Filter");

        setExtHomeName(homeRoleMap["homeName"] || "");
        setExtRoleName(homeRoleMap["roleName"] || "");

        fetchCourseDetails(homeRoleMap["homeId"], homeRoleMap["roleId"]);

        setExternalSearch(true);
        setFilterSearch(false);

        sethomeDropdownValue(0);
        setroleDropdownValue(0);
        updateCurrentPolicyDataList([]);
        updatePendingPolicyCount(0);
        updatePendingCourseCount(0);

    }


    function CustomNoRowsOverlay() {
        return (
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
                <Typography gutterBottom><ErrorOutlineIcon style={{ fontSize: "2pc" }} /></Typography>
                <Typography variant="h5" gutterBottom>{(homeDropdownValue === 0 || roleDropdownValue === 0 || homeId === 0 || roleId === 0) ? "No filter selected" : "No Courses assigned for this role"}</Typography>
                <Typography variant='caption' gutterBottom>This home has not assigned any courses to this Role for you to complete.</Typography>
            </Box>
        );
    }

    const handleTabChange = (event, newValue) => {
        setTabIndex(newValue);
        setReportType(newValue);
        calculatePieData([], newValue);
    };

    const handleReportChange = (event, newAlignment) => {
        setReportType(newAlignment);
        calculatePieData([], newAlignment);
    };


    return (
        <div style={{ fontFamily: "'Open Sans', sans-serif" }}>

            <Container fluid>
                <Sheet variant='soft' color='primary' sx={{ borderRadius: "md" }}>
                    <Row className="w-70" style={{ padding: "1pc", mb: (fieldSize === "md") ? 0 : 1 }} >
                        <Col xs={12} md={6}>
                            <FloatingLabel
                                controlId="floatingHome"
                                label="Active Home"
                                size={fieldSize}
                            >
                                <Form.Select size={fieldSize} aria-label="Floating label select example" value={homeDropdownValue} onChange={filterRoleDropdown}>
                                    <option value="0" > -- Please select home --  </option>
                                    {mapHomeList?.map((data, id) => (
                                        <option value={data.home_id} key={data.home_id}>{data.name}</option>
                                    ))}
                                </Form.Select>
                            </FloatingLabel>
                        </Col>
                        <Col xs={12} md={6}>
                            <FloatingLabel
                                controlId="floatingRole"
                                label={(roleLabel.includes("Pending")) ? <><Warning style={{ fontSize: "1.2pc", marginBottom: "5px" }} variant="danger" />&nbsp;{roleLabel}</> : roleLabel}
                                style={{ color: (roleLabel.includes("Pending")) ? "red" : "" }}
                            >
                                <Form.Select size={fieldSize} aria-label="Floating label select example" value={roleDropdownValue} onChange={setRoleValue}>
                                    <option value="0"> -- Please select role --  </option>
                                    {mapRoleList?.map((data, id) => (
                                        <option value={data.role_id} key={data.role_id}>{data.role_name}</option>
                                    ))}
                                </Form.Select>
                            </FloatingLabel>

                        </Col>
                    </Row>
                    <Row style={{ paddingLeft: "1pc" }}>
                        {/* <div className="d-flex justify-content-between align-items-center" >
                                <Typography variant="caption" component="div" sx={{ pl: 3 }}>
                                    <ContactSupportOutlinedIcon fontSize="small" color="primary"/>&nbsp;Filter by Home and Role to view assigned courses & home docs.
                                </Typography>
                            </div> */}
                        <HelpIconInfo
                            link={"https://carepassportcareltc.atlassian.net/wiki/external/ZDYxZTc1ZTk5OTViNGVhM2I1NjkyOGRkMGRlNDI5YTE"}
                            msg={"Filter by Home and Role to view assigned courses & home docs."} />
                    </Row>
                    <Row>
                        <Col xs={12}>
                            <AccordionGroup
                                variant="soft"
                                color='primary'
                                transition="0.2s"
                                borderRadius="md"
                                sx={(theme) => ({
                                    width: "100%",
                                    //borderRadius: '0 0 6px 6px',
                                    //borderColor:"#fbfcfe",
                                    [`& .${accordionSummaryClasses.button}:hover`]: {
                                        bgcolor: '#dee8f2'

                                    },
                                    [`& .${accordionDetailsClasses.content}`]: {
                                        boxShadow: `inset 0 1px ${theme.vars.palette.divider}`,
                                        [`&.${accordionDetailsClasses.expanded}`]: {
                                            paddingBlock: '0.75rem',
                                        },
                                    },
                                })}

                            >
                                <Accordion defaultExpanded={false}>
                                    <AccordionSummary
                                        variant="soft"
                                        color='primary'
                                        sx={{
                                            display: 'flex',
                                            justifyContent: 'center',
                                            alignItems: 'center',
                                            textAlign: 'center',
                                            borderRadius: 'md',
                                            [`& .${accordionSummaryClasses.button}`]: {
                                                display: 'flex',
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                gap: '0.5rem',
                                            },
                                            '& .joy-AccordionSummary-content, & .MuiAccordionSummary-content': {
                                                justifyContent: 'center',
                                                alignItems: 'center',
                                                display: 'flex',
                                            },
                                        }}
                                    >
                                        <Typography variant='body-sm' sx={{ fontWeight: 300 }} ><ScienceIcon fontSize="small" />&nbsp;Advanced Search</Typography>
                                    </AccordionSummary>
                                    <AccordionDetails variant="soft" sx={{ backgroundColor: "#dee8f2", borderRadius: '0 0 6px 6px' }}>

                                        <Stack direction={stackOrientation} justifyContent="space-between" alignItems="center">
                                            <Typography variant="caption" component="div" sx={{ pl: 3 }}>
                                                Use "Other Homes" to search across all homes or "All Courses" to view all courses.
                                            </Typography>

                                            <Box sx={{ display: 'flex', gap: 2, pr: 3 }}>
                                                <Button size={fieldSize} onClick={() => setAllHomeBox(true)} startDecorator={<ManageSearchIcon />} variant="solid">Other Homes</Button>
                                                <Button size={fieldSize} onClick={() => resetDetails()} startDecorator={<FaAlignJustify />} variant="solid">All Courses</Button>
                                            </Box>
                                        </Stack>

                                    </AccordionDetails>
                                </Accordion>

                            </AccordionGroup>
                        </Col>
                    </Row>
                </Sheet>

            </Container>
            <br></br>
            <Container fluid>
                <Tabs variant="outlined" disableIndicator value={tabIndex} onChange={handleTabChange} aria-label="Carepassport Training Panel" sx={{ width: '100%', borderRadius: 'sm', boxShadow: 'sm', overflow: 'auto' }}>
                    <TabList disableUnderline disableIndicator
                        tabFlex={1}
                        sx={{
                            [`& .${tabClasses.root}`]: {
                                padding: 1,
                                margin: 1,
                                fontSize: 'sm',
                                fontWeight: 'lg',
                                borderRadius: '40px',
                                border: '1.5px solid #016799',
                                color: '#016799',
                                transition: 'background 0.2s, color 0.2s',
                                [`&[aria-selected="true"]`]: {
                                    color: 'white',
                                    bgcolor: '#016799',
                                    border: '1.5px solid #016799',
                                    borderRadius: '40px',
                                    '& svg': {
                                        color: 'white',
                                    },
                                },
                                [`&[aria-selected="false"]`]: {
                                    background: 'white',
                                    color: '#016799',
                                    border: '1.5px solid #016799',
                                    '& svg': {
                                        color: '#016799',
                                    },
                                },
                                [`&.${tabClasses.focusVisible}`]: {
                                    outlineOffset: '-4px',
                                },
                            },
                            backgroundColor: 'white',
                            borderColor: '#016799',
                            borderWidth: '1.5px',

                        }}>
                        <Tab disableIndicator orientation="horizontal" {...(tabIndex === 0 && { color: colors[0] })} sx={{ mt: 1 }}>
                            <ListItemDecorator sx={{ py: 0.5 }}>
                                <Badge color="warning" badgeContent={pendingCourseCount}>
                                    <NewspaperOutlinedIcon />
                                </Badge>
                            </ListItemDecorator>
                            Assigned Courses
                        </Tab>
                        <Tab disableIndicator orientation="horizontal" {...(tabIndex === 1 && { color: colors[1] })} sx={{ mt: 1 }}>
                            <ListItemDecorator sx={{ py: 0.5 }}>
                                <Badge color="warning" badgeContent={pendingPolicyCount}>
                                    <DocumentScannerOutlinedIcon />
                                </Badge>
                            </ListItemDecorator>
                            Assigned Home Docs
                        </Tab>
                    </TabList>
                    <TabPanel value={0}>
                        <Paper elevation={0} className='p-2 mb-1' square sx={{ bgcolor: 'transparent' }}>
                            <Row>
                                <Col>
                                    {(alertshow) && <Alert severity="error" className='text-center'>{waitMsg}</Alert>}
                                    {(successAlertshow && !externalSearch) && <Alert severity="success">Course completions and Home Doc review status are being shared with this Home.</Alert>}
                                    {(externalSearch) && <Alert severity="success">Filtered By {" - "} {extHomeName} {" > "} {extRoleName}</Alert>}

                                    <Snackbar
                                        open={alertshow}
                                        autoHideDuration={6000}
                                        onClose={() => setalertShow(false)}
                                        severity="error"
                                        message="You got an error!"

                                    />

                                    <Snackbar
                                        open={successAlertshow}
                                        autoHideDuration={6000}
                                        onClose={() => setsuccessAlertshow(false)}
                                        message="Course completions and Home Doc review status are being shared with this Home."

                                    />
                                </Col>
                            </Row>
                            <Row>
                                <HelpIconInfo
                                    link={"https://carepassportcareltc.atlassian.net/wiki/external/MDE5MTM5Yzc1YzYyNDY3MWI0OGVhMDI2OTIwZTI0MTA"}
                                    msg={"Register for Assigned Courses"}
                                />
                            </Row>
                            <Row>
                                {/* <Col xs={12} md={12}>
                                    <div style={{ width: '100%' }}>
                                        <BootstrapTable columns={columns}
                                            keyField="crsId"
                                            data={completeCourses}
                                            ref={tableRef}
                                            pagination={getPaginationFactory(completeCourses)}
                                            filter={filterFactory()}
                                            expandRow={expandRow}
                                            filterPosition="top"
                                            noDataIndication={noDataMessage}
                                            hover
                                            condensed
                                            style={customTableStyle}
                                        />
                                    </div>
                                    <br></br> */}
                                <Box
                                    sx={{
                                        flexGrow: 1,
                                        borderTopLeftRadius: '12px',
                                        borderTopRightRadius: '12px',
                                        bgcolor: `${'var(--colors-index)'}.500`,
                                        height: 500,
                                        width: "98%",
                                        margin: "auto",
                                        mt: 2,
                                        "& .MuiDataGrid-columnHeaders": {
                                            backgroundColor: "#016799",
                                            color: "#fff",
                                            borderRadius: "4px 4px 0 0",
                                        },
                                        "& .MuiDataGrid-columnSeparator": {
                                            display: "none", // cleaner header look
                                        },
                                        "& .MuiDataGrid-cell": {
                                            borderBottom: "1px solid #e0e0e0",
                                        },
                                        "& .MuiDataGrid-row:hover": {
                                            backgroundColor: "#f5faff", // light hover
                                        },

                                    }}

                                >
                                    <DataGrid
                                        rows={completeCourses}
                                        columns={data_tables_columns}
                                        getRowId={(row) => row.crsId}
                                        slots={{
                                            variant: 'linear-progress',
                                            noRowsVariant: 'skeleton',
                                            noRowsOverlay: CustomNoRowsOverlay,

                                        }}
                                        initialState={{
                                            pagination: {
                                                paginationModel: {
                                                    pageSize: 20,
                                                },
                                            },
                                        }}
                                        pageSizeOptions={[5, 20, 50]}
                                        disableRowSelectionOnClick
                                        autosizeOptions={{
                                            columns: ['name', 'status', 'createdBy'],
                                            includeOutliers: true,
                                            includeHeaders: false,
                                        }}
                                        sx={{
                                            maxHeight: 1200, minHeight: 500,
                                            '& .MuiTablePagination-selectLabel ': { pt: '0.9rem', color: '#016799' },
                                            '& .MuiTablePagination-displayedRows': { pt: '0.9rem', color: "#016799" }
                                        }}
                                        showToolbar
                                    /></Box>
                                {/* </Col> */}
                            </Row>
                        </Paper>
                    </TabPanel>
                    <TabPanel value={1}>
                        <PolicyDetails />
                    </TabPanel>
                </Tabs>

                <br></br>
                <br></br>
                <Card variant='outlined' sx={{ backgroundColor: "white", mb: 3 }}>
                    <Row>
                        <br></br>
                        <Typography align='center' className='mt-2' sx={{ color: "#006699" }} variant='h5'> Completion Report </Typography>
                        <Divider sx={{
                            my: 2, width: "100%", maskImage: 'linear-gradient(to right, transparent, black 20%, black 80%, transparent)',
                            WebkitMaskImage: 'linear-gradient(to right, transparent, black 20%, black 80%, transparent)',
                            borderBottomWidth: 2, backgroundColor: 'text.primary'
                        }} />
                        <Row>
                            <Col xs={12} md={6} className='p-4'>
                                <Card variant="soft" color='primary' sx={{ p: 3 }}>
                                    <HelpIconInfo
                                        link={"https://carepassportcareltc.atlassian.net/wiki/external/ZDZkYWEwZDM1MDI0NDZmODhkY2EwMjliZTZkNTJhYjU"}
                                        msg={"Download a copy of your Care Passport"} />
                                    <CardContent>
                                        <ToggleButtonGroup
                                            color="primary"
                                            size={"small"}
                                            orientation={fieldSize === 'sm' ? 'vertical' : 'horizontal'}
                                            variant="solid"
                                            value={reportType}
                                            exclusive
                                            onChange={handleReportChange}
                                            aria-label="Platform"
                                            sx={{
                                                "backgroundColor": "#fff", borderRadius: "20px 20px 20px 20px", mb: 1, width: "100%",
                                                "& .MuiToggleButton-root": { borderColor: '#016799', color: '#016799' }, "&. MuiToggleButton-root.Mui-hover": { bgcolor: '#f0f8ff' },
                                                "& .MuiToggleButton-root.Mui-selected": { bgcolor: '#016799', color: '#fff' }
                                            }}
                                        >
                                            <ToggleButton value={0} sx={{ width: "100%", fontSize: '0.875rem', borderRadius: "20px 0 0 20px", textTransform: 'none' }} aria-label="course-report-tab">Courses</ToggleButton>
                                            <ToggleButton value={1} sx={{ width: "100%", fontSize: '0.875rem', textTransform: 'none' }} aria-label="policy-report-tab">Home Docs</ToggleButton>
                                            <ToggleButton value={2} sx={{ width: "100%", fontSize: '0.875rem', borderRadius: "0 20px 20px 0", textTransform: 'none' }} aria-label="both-report-tab">Both</ToggleButton>
                                        </ToggleButtonGroup>
                                        <br></br>
                                        <Grid container spacing={2}>
                                            <Grid xs={12}>
                                                <FormControl>
                                                    <FormLabel>Report Format</FormLabel>
                                                    <Select
                                                        placeholder="Select report format ... "
                                                        size={fieldSize}
                                                        slotProps={{
                                                            listbox: {
                                                                placement: 'bottom-start',
                                                            },
                                                        }}
                                                        name="format"
                                                        onChange={(e, newValue) => formatChange(newValue)}
                                                    >
                                                        <Option value="excel" key="1">Excel</Option>
                                                        <Option value="pdf" key="2">PDF</Option>
                                                    </Select>
                                                </FormControl>
                                            </Grid>
                                            <Grid xs={12}>
                                                <FormControl>
                                                    <FormLabel>Email</FormLabel>
                                                    <Input size={fieldSize} placeholder="Enter your email…" name="email" onBlur={updateEmpEmailId} variant="outlined" />
                                                </FormControl>
                                            </Grid>
                                        </Grid>
                                        <Grid container spacing={3}>
                                            <Grid xs={12}>
                                                <Stack direction={stackOrientation} justifyContent="space-between" gap={2} alignItems="center" sx={{ p: 1 }}>
                                                    <Checkbox label="Verify & Send email" onChange={() => setAuditCheck(false)} color="primary" variant='solid' defaultChecked />

                                                    <Box sx={{ display: 'flex', gap: 4, flexWrap: 'wrap' }}>
                                                        <Button size={fieldSize} onClick={() => sendDataThroughEmail()} startDecorator={<ForwardToInboxOutlinedIcon />} variant="solid">Send</Button>
                                                        <Button size={fieldSize} onClick={() => downloadData()} startDecorator={<FaDownload />} variant="solid" >Download</Button>
                                                    </Box>

                                                </Stack>
                                            </Grid>
                                        </Grid>
                                    </CardContent>
                                </Card>

                            </Col>

                            <Col xs={12} md={6} className='p-4'>
                                <PieChart
                                    series={[
                                        {
                                            data: pieData,
                                            innerRadius: 5, cornerRadius: 4, paddingAngle: 2,
                                            highlightScope: { faded: 'global', highlighted: 'item' },
                                            faded: { innerRadius: 30, additionalRadius: -30, color: 'gray' },
                                        },
                                    ]}
                                    height={200}
                                />
                            </Col>
                        </Row>
                    </Row>
                    <br></br>
                </Card>
            </Container>
            <Modal show={showSpinner} centered backdrop="static" style={{ "width": "5pc", "top": "20%", "left": "50%" }} keyboard={false}>
                <Modal.Body className='text-center'>
                    <Spinner variant='primary' role="status" animation="border" />
                </Modal.Body>
            </Modal>
            <SuccessPopUp show={showSuccess} data={successMsg} onHide={() => { setShowSuccess(false) }} />
            <ErrorPopUp show={showErrorMsg} data={errorMsg} onHide={() => { setShowErrorMsg(false) }} />
            <HomeRoleForUser open={allHomesBox} home={homeList} role={roleList} onSubmit={handleModalData} onClose={() => { setAllHomeBox(false) }} userId={params} />
            <CourseVersionDetails data={selectedRowRef.current} userId={params} open={courseVersionModal}
                onClose={() => setCourseVersionModal(false)}
                handleUpdateCallback={handleUpdateCallback}
            />
            <RoleConfirmationPopup open={pendingRole} onClose={() => { setPendingRole(false); fetchCourseDetails(); }} onConfirm={() => confirmRole()} />
            <ParentCoursePopup open={parentCoursePopupFlag} onClose={() => setParentCoursePopupFlag(false)} courseData={selectedRowParentCourseRef} />
            <CourseRegistrationHistory open={courseHistoryPopupFlag} onClose={() => setCourseHistoryPopupFlag(false)} courseDataFromParent={courseBadgeTableData || []} />
        </div>

    )
}

export default ManageMyTrainings;



